<sd-icon [type]="iconTypes.HISTORY"></sd-icon>
{{ text }}
